
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import Head from "next/head";
import "../styles/globals.css";
import "../store";
import { pageview, gaEvent } from "../lib/ga";
import dynamic from "next/dynamic";
import { YandexMetricaProvider } from "../lib/next-yandex-metrica";
import { initWebsocketConnect, websocket } from "../services/websocket";
import { signInStatus } from "../redux/signIn";
import { setLoadingBar } from "../redux/siteData";
import { setBoardSize, setSetting } from "../redux/settings";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { Provider } from "hooks-for-redux";
import { ErrorBoundary } from "react-error-boundary";
// import posthog from "posthog-js-lite";
// import { PostHogProvider } from "posthog-js/react";
const Navigation = dynamic(() => import("../navigation/Navigation"));
const Footer = dynamic(() => import("../navigation/Footer"));
const Popup = dynamic(() => import("../components/ui/popup"));
const EmailActivationBanner = dynamic(() => import("../components/common/email-activation-banner"));
// import { GrowthBookProvider } from "@growthbook/growthbook-react";
// import { growthbook } from "../util/growthbook";
import { idleLoadScripts } from "../idleLoadScripts";
import { loadAds } from "../loadAds";
import { shouldLoadAdsForPath } from "../config/ads";
import { setEmailNotActivated } from "@/redux/user";
import Script from "next/script";
const FALLBACK_HOST = "www.chesshotel.com";
declare global {
    interface Window {
        gtag: any;
        googlefc: any;
        adsbygoogle: any;
        AppleID: any;
        fbAsyncInit: any;
        Stripe: any;
        __cmp: any;
        setCookie: any;
        __tcfapi: any;
        google: any;
        chesshotel: any;
        chesshotelPuzzle: any;
        fusetag: any;
        FB: any;
        dataLayer: any;
        google_optimize: any;
        ramp: any;
        yaContextCb: any;
        Ya: any;
        _pwGA4PageviewId: any;
        workbox: any;
        userHasInteracted: boolean;
        webkitAudioContext: any;
        requestIdleCallback: (callback: IdleRequestCallback, options?: IdleRequestOptions) => number;
        ym: any;
        __gameReviewFlag: boolean;
        __google_initialized: boolean;
        googletag: any;
        pbjs: any;
    }
}
function getBaseUrl() {
    const host = process.env.NEXT_PUBLIC_HOST || FALLBACK_HOST;
    const withProtocol = host.startsWith("http://") || host.startsWith("https://")
        ? host
        : `https://${host}`;
    return withProtocol.endsWith("/") ? withProtocol.slice(0, -1) : withProtocol;
}
function normalizePath(path: string) {
    if (!path)
        return "/";
    const withoutHash = path.split("#")[0];
    const withoutQuery = withoutHash.split("?")[0];
    if (!withoutQuery)
        return "/";
    const withSlash = withoutQuery.startsWith("/")
        ? withoutQuery
        : `/${withoutQuery}`;
    if (withSlash.length > 1 && withSlash.endsWith("/")) {
        return withSlash.slice(0, -1);
    }
    return withSlash;
}
function stripLocalePrefix(path: string, locale: string | undefined, defaultLocale: string) {
    if (!locale || locale === defaultLocale)
        return path;
    const prefix = `/${locale}`;
    if (path === prefix)
        return "/";
    if (path.startsWith(`${prefix}/`)) {
        return path.slice(prefix.length);
    }
    return path;
}
function buildLocalePath(locale: string, path: string, defaultLocale: string) {
    if (locale === defaultLocale)
        return path;
    if (path === "/")
        return `/${locale}`;
    return `/${locale}${path}`;
}
function initSettings() {
    try {
        const chessSet = localStorage.getItem("chessSet");
        if (chessSet) {
            setSetting({ name: "chessSet", val: chessSet });
        }
    }
    catch (e) {
        console.log(e);
    }
}
function ErrorFallback({ error, resetErrorBoundary }) {
    return (<Popup onClose={null} title="Something went wrong">
      <div className="flex flex-col items-center justify-center w-full pt-4 mt-4">
        <div className="mb-6">{error.message}</div>
        <button className="btn btn-base btn-blue" onClick={resetErrorBoundary}>
          Try again
        </button>
      </div>
    </Popup>);
}
const myErrorHandler = (error: Error, info: {
    componentStack: string;
}) => {
    import("../redux/ping").then((module) => {
        const { setError, setErrorData, ERROR_BOUNDRY, sendPingData } = module;
        setError(ERROR_BOUNDRY);
        setErrorData({
            errorMsg: "version9 " + error.message,
            componentStack: info.componentStack,
        });
        sendPingData();
    });
};
// let lastUrl: string | null = null;
function MyApp({ Component, pageProps, userData }) {
    const router = useRouter();
    const defaultLocale = router.defaultLocale || "en";
    const currentLocale = router.locale || defaultLocale;
    const locales = router.locales && router.locales.length > 0
        ? router.locales.filter(Boolean)
        : [defaultLocale];
    const baseUrl = getBaseUrl();
    const normalizedPath = normalizePath(router.asPath || "/");
    const pathWithoutLocale = stripLocalePrefix(normalizedPath, currentLocale, defaultLocale);
    const isLegalPath = pathWithoutLocale === "/termsofservice" ||
        pathWithoutLocale === "/privacypolicy";
    const canonicalLocale = isLegalPath && currentLocale !== defaultLocale
        ? defaultLocale
        : currentLocale;
    const canonicalPath = buildLocalePath(canonicalLocale, pathWithoutLocale, defaultLocale);
    const canonicalUrl = `${baseUrl}${canonicalPath}`;
    const shouldRenderAlternates = !isLegalPath || currentLocale === defaultLocale;
    const xDefaultHref = `${baseUrl}${buildLocalePath(defaultLocale, pathWithoutLocale, defaultLocale)}`;
    const currentPath = router.pathname;
    const gamePath = currentPath.startsWith("/game") ||
        currentPath.startsWith("/daily/game") ||
        currentPath.startsWith("/analysis");
    const validateEmailPath = currentPath.startsWith("/register/validateEmail");
    // const gameReviewPath = currentPath.startsWith("/game-review");
    const noWsConnect = validateEmailPath;
    const iframePath = currentPath.startsWith("/iframe");
    const hideFooter = gamePath || iframePath || validateEmailPath;
    const hideNavigation = iframePath || validateEmailPath;
    useEffect(() => {
        if (!websocket && !noWsConnect) {
            signInStatus();
        }
        initSettings();
        setBoardSize();
        idleLoadScripts(currentPath);
        function onUserInteraction() {
            window.userHasInteracted = true;
            document.removeEventListener("click", onUserInteraction);
            document.removeEventListener("mousedown", onUserInteraction);
            document.removeEventListener("touchstart", onUserInteraction);
            // Dispatch custom event for deferred operations
            window.dispatchEvent(new Event("userHasInteracted"));
        }
        document.addEventListener("touchstart", onUserInteraction);
        document.addEventListener("mousedown", onUserInteraction);
        document.addEventListener("click", onUserInteraction);
        // Listen for email verification events from other tabs
        let emailVerifiedChannel: BroadcastChannel | null = null;
        if (typeof BroadcastChannel !== "undefined") {
            emailVerifiedChannel = new BroadcastChannel("chesshotel-email-verified");
            emailVerifiedChannel.onmessage = (event) => {
                if (event.data?.type === "EMAIL_VERIFIED") {
                    // Refresh user status to update emailNotActivated flag
                    setEmailNotActivated(false);
                }
            };
        }
        return () => {
            document.removeEventListener("click", onUserInteraction);
            document.removeEventListener("mousedown", onUserInteraction);
            document.removeEventListener("touchstart", onUserInteraction);
            if (emailVerifiedChannel) {
                emailVerifiedChannel.close();
            }
        };
    }, []);
    useEffect(() => {
        // posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        //   api_host:
        //     process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://eu.i.posthog.com",
        //   autocapture: false,
        //   capture_pageview: false,
        //   person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
        //   // Enable debug mode in development
        //   loaded: (posthog) => {
        //     if (process.env.NODE_ENV === "development") posthog.debug();
        //   },
        // });
        // lastUrl = currentPath;
        let routeStartTime: number;
        let loadingBarTimeout: NodeJS.Timeout | null = null;
        const handleStart = (url: string) => {
            routeStartTime = performance.now();
            console.log(`[Route] Start: ${url} at ${routeStartTime.toFixed(0)}ms`);
            // Only show loading bar if navigation takes longer than 100ms
            loadingBarTimeout = setTimeout(() => setLoadingBar(true), 100);
        };
        const handleStop = (url: string) => {
            const duration = performance.now() - routeStartTime;
            console.log(`[Route] Complete: ${url} - took ${duration.toFixed(0)}ms`);
            // Clear timeout and hide loading bar
            if (loadingBarTimeout) {
                clearTimeout(loadingBarTimeout);
                loadingBarTimeout = null;
            }
            setLoadingBar(false);
            pageview(url);
            // Use centralized path checking for ads
            if (shouldLoadAdsForPath(url)) {
                loadAds();
            }
            // If leaving game-review pages, (re)connect WS when needed
            // if (
            //   lastUrl.includes("/game-review") &&
            //   !url.includes("/game-review") &&
            //   !websocket
            // ) {
            //   initWebsocketConnect();
            // }
            // posthog?.capture("$pageview");
            // growthbook.setURL(window.location.href);
            // lastUrl = url;
        };
        const handleError = () => {
            if (loadingBarTimeout) {
                clearTimeout(loadingBarTimeout);
                loadingBarTimeout = null;
            }
            setLoadingBar(false);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleStop);
        router.events.on("routeChangeError", handleError);
        return () => {
            if (loadingBarTimeout) {
                clearTimeout(loadingBarTimeout);
            }
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleStop);
            router.events.off("routeChangeError", handleError);
        };
    }, [router.events]);
    return (<>
      {/*
        //@ts-ignore */}
      <Provider>
        <YandexMetricaProvider tagID={103551128} initParameters={{
            clickmap: false,
            webvisor: false,
            accurateTrackBounce: true,
            trackLinks: true,
        }} strategy="lazyOnload" router="pages">
          <Head>
            <meta name="viewport" content="viewport-fit=cover, width=device-width, height=device-height, initial-scale=1, shrink-to-fit=no, maximum-scale=1, user-scalable=no"/>
            <link rel="canonical" href={canonicalUrl}/>
            {shouldRenderAlternates &&
            locales.map((locale) => {
                const href = `${baseUrl}${buildLocalePath(locale, pathWithoutLocale, defaultLocale)}`;
                return (<link rel="alternate" hrefLang={locale} href={href} key={`alt-${locale}`}/>);
            })}
            {shouldRenderAlternates && (<link rel="alternate" hrefLang="x-default" href={xDefaultHref} key="alt-x-default"/>)}
          </Head>
          {!hideNavigation && <Navigation />}
          <EmailActivationBanner />
          <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => {
            window.location.reload();
        }} onError={myErrorHandler}>
            {/* <GrowthBookProvider growthbook={growthbook}> */}
            <Component {...pageProps}/>
            {/* </GrowthBookProvider> */}
          </ErrorBoundary>
          {!hideFooter && <Footer />}
        </YandexMetricaProvider>
      </Provider>
    </>);
}
const __Next_Translate__Page__19be5cfa2f1__ = MyApp;

    export default __appWithI18n(__Next_Translate__Page__19be5cfa2f1__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  